import * as gtag from "utils/gtag"; 
export const handlerOpenModalChangePassword = (modal) => {
  gtag.event({
    action: "click",
    category: "efficient-purchase",
    label: "button__log-out",
    value: 0,
  });
  modal.toggle();
}